export const ICONS = {
  student: "https://raw.githubusercontent.com/Tarikul-Islam-Anik/Animated-Fluent-Emojis/master/Emojis/People/Person%20Raising%20Hand.png",
  school: "/images/School.png",
  books: "/images/Books.png",
  party: "/images/Party_Popper.png",
  phone: "/images/Telephone_Receiver.png",
  memo: "/images/Memo.png",
  pin: "/images/Pushpin.png",
  baby: "/images/Baby.png",
  prayer: "/images/prayer_3d.png",
  calendar: "/images/Calendar.png",
  msg: "/images/Envelope.png",
  crown: "/images/Crown.png",
  birthdaycake: "/images/birthday_cake_animated.png",
  sparkles: "/images/Sparkles.png",
  attendance: "/images/Bar_chart.png",
  warning: "/images/Warning.png",
  teacher: "/images/Teacher.png",
  teacher_male: "/images/teacher_3d_light.png",
  teacher_female: "/images/woman_teacher_3d_light.png",
};

export const FAITH_STATE_STYLES = {
  "초신자": "bg-amber-400 text-white border-amber-400",
  "기존신자": "bg-[#354F38] text-white border-[#354F38]",
  "양육중": "bg-blue-500 text-white border-blue-500",
  "시험듦": "bg-rose-500 text-white border-rose-500",
  "장기결석": "bg-gray-400 text-white border-gray-400",
};

export const DEPARTMENTS = [
  "영아부",
  "유아부",
  "유치부",
  "유년부",
  "초등부",
  "중등부",
  "고등부",
  "청년부",
  "장년부",
  "기타",
];
